// extracted by mini-css-extract-plugin
export var eyebrow = "_l2-3";
export var heroImage = "_l2-4";
export var main = "_l2-2";
export var modal = "_l2-0";
export var shell = "_l2-1";